import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Form, Input, Button, Row, Col, Select, notification } from 'antd';
import { FormattedMessage } from "react-intl";
import countryList from 'react-select-country-list'
import { cw, hp } from "../../utils";

import AuthHeader from './Header';

const CreateAccount = (props) => {
    const { intl, _utils } = props;

    const [form] = Form.useForm();
    const [countries] = useState(() => countryList().getData());
    const [screen] = useState(0);
    const [submitting, setSubmitting] = useState(false);

    useEffect(() => {
        ipinfo();
    }, []); // eslint-disable-line react-hooks/exhaustive-deps

    const ipinfo = () => {
        axios({
            method: 'POST',
            url: `${hp.getApiBaseUrl()}/ipinfo`,
            json: true
        }).then((res) => {
            if (res.data.country_name) {
                form.setFieldsValue({ organizationCountry: res.data.country_name });
            }
        }).catch(() => {});
    };

    const _signup = (v) => {
        setSubmitting(true);
        axios({
            method: 'POST',
            url: `${hp.getApiBaseUrl()}/users/${hp.getCookie('user_id')}/accounts`,
            json: true,
            data: {
                name: v.organizationName,
                industry: v.industry,
                country: v.organizationCountry,
            },
            headers: {
                'x-access-token': hp.getCookie('user_token')
            }
        }).then((res) => {
            if (res.data.statusCode === 200) {
                hp.setCookie('project_id', res.data.data.id);
                hp.setCookie('active_account', JSON.stringify(res.data.data));
                axios({
                    method: 'POST',
                    url: `${hp.getApiBaseUrl()}/auth/account-logins`,
                    headers: { 'x-access-token': hp.getCookie('user_token') },
                    data: {
                        accountId: res.data.data.id,
                        userId: hp.getCookie('user_id'),
                    }
                }).then((response) => {
                    const result = response.data;
                    if (result.statusCode === 200) {
                        hp.setCookie('user_token', result.token);
                        window.location.assign(hp.getSuccessRedirect());
                    } else {
                        notification.error({ message: intl.formatMessage(cw['SwitchAccount.Failed']) });
                    }
                }).catch(() => {
                    notification.error({ message: intl.formatMessage(cw['SwitchAccount.Failed']) });
                });
            } else {
                setSubmitting(false);
                notification.error({
                    message: intl.formatMessage(cw['Failed']),
                    description: intl.formatMessage(cw['Signup.Failed'])
                });
            }
        }).catch(() => {
            setSubmitting(false);
            notification.error({
                message: intl.formatMessage(cw['Failed']),
                description: intl.formatMessage(cw['Signup.Failed'])
            });
        });
    };

    return (
        <React.Fragment>
            <Form id="esoko__signin" form={form} layout="vertical" requiredMark={false} onFinish={_signup}>
                <AuthHeader screen="signup" />

                {/* Organisation details */}
                <Row gutter={16} className={screen === 1 ? 'hide' : ''}>
                    <Col span={24}>
                        <p><b><FormattedMessage id="Signup.Title.Organisation" defaultMessage="Please provide the details of your organization" /></b></p>
                    </Col>
                    <Col span={24}>
                        <div>
                            <Form.Item
                                colon={false}
                                label={<FormattedMessage id="Label.Organisation" defaultMessage="Organisation name" />}
                                name="organizationName"
                                rules={[
                                    { required: true, message: <FormattedMessage id="Rules.Organisation.Required" defaultMessage="Please provide organisation" /> },
                                    { min: 2, message: <FormattedMessage id="Rules.Organisation.Min2" defaultMessage="Organisation name must be at least 2 characters" /> },
                                    { max: 50, message: <FormattedMessage id="Rules.Organisation.Max50" defaultMessage="Organisation name cannot be longer than 50 characters" /> },
                                ]}
                            >
                                <Input size="large" type="text" autoComplete="off" sso-id="signup-organizationName" />
                            </Form.Item>
                        </div>
                    </Col>
                    <Col span={24}>
                        <div>
                            <Form.Item
                                colon={false}
                                label={<FormattedMessage id="Label.Industry" defaultMessage="Industry" />}
                                name="industry"
                                rules={[
                                    { required: true, message: <FormattedMessage id="Rules.Industry.Required" defaultMessage="Please provide industry" /> }
                                ]}
                            >
                                <Select
                                    size="large" showSearch={Object.keys(_utils.industries).length > 5} sso-id="signup-industry"
                                    placeholder={intl.formatMessage(cw['Placeholder.Industry'])}
                                >
                                    {Object.keys(_utils.industries).map(industry => (
                                        <Select.Option key={industry} value={industry}>{_utils.industries[industry]}</Select.Option>
                                    ))}
                                </Select>
                            </Form.Item>
                        </div>
                    </Col>
                    <Col span={24}>
                        <Form.Item
                            colon={false}
                            label={<FormattedMessage id="Label.Country" defaultMessage="Country" />}
                            name="organizationCountry"
                            initialValue="Ghana"
                            rules={[
                                { required: true, message: <span /> },
                            ]}
                        >
                            <Select size="large" showSearch={true} sso-id="signup-organizationCountry">
                                {countries.map(cnt => (
                                    <Select.Option key={cnt.label} value={cnt.label}>{cnt.label}</Select.Option>
                                ))}
                            </Select>
                        </Form.Item>
                    </Col>
                    <Col span={24}>
                        <Form.Item noStyle shouldUpdate={(prev, curr) => prev.organizationName !== curr.organizationName || prev.industry !== curr.industry}>
                            {({ getFieldValue }) => (
                                <Form.Item>
                                    <Button
                                        className="submitBtn" block size="large" type="primary" htmlType="submit" sso-id="signup-proceed"
                                        disabled={!getFieldValue('organizationName') || !getFieldValue('industry')}
                                        loading={submitting}
                                    >
                                        <FormattedMessage id="Button.CreateAccount" defaultMessage="Create Account" />
                                    </Button>
                                </Form.Item>
                            )}
                        </Form.Item>
                    </Col>
                </Row>
            </Form>
        </React.Fragment>
    );
};

export default CreateAccount;